<template>
    <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <v-row
      :style="{gap: '1rem', marginLeft: '1rem !important'}">
        <v-btn
          class="back"
          dark
          icon
          to="/"
        >
          <v-icon
          :style="{color: '#27846d !important', fontSize: '34px'}"
          >
            icon-ayudadigital-volver
          </v-icon>
        </v-btn>
        <!-- <h2> {{ $t('views.utils.acortador.title') }} </h2> -->
      </v-row>
        <v-container class="registered-container"  fluid>
            <!-- TITLE -->
          <v-row justify="center">
            <v-icon class="mr-1" color="success" size="40">
                mdi-check-circle
            </v-icon>
            <h2 :style="{textAlign: 'center'}">
              {{ $t('views.registered.title',[name]) }}
            </h2>
          </v-row>
            <!-- SUBTITLE -->
          <v-row justify="center">
            <p class="mt-3"
            :style="{textAlign: 'center'}"> {{ $t('views.registered.subtitle') }} </p>
          </v-row>
            <!-- DETAILS BUTTON -->
          <v-row justify="center" class="rowCard">
            <v-col cols="3"
            :style="{display: 'flex', justifyContent: 'center', alignItems: 'center'}">
                <v-icon size="80">
                    mdi-magnify
                </v-icon>
            </v-col>
            <v-col :cols="sizeScreen > sizeMobile ? '5' : '9'" class="">
            <!-- <v-col sm="5" xs="9" class=""> -->
                <div class="mt-3">
                    <h3>{{ $t('views.registered.titleDetails') }}</h3>
                    <p>{{ $t('views.registered.subtitleDetails') }}</p>
                </div>
            </v-col>
            <!-- <v-col sm="4" xs="12" class="btnDetail" -->
            <v-col :cols="sizeScreen > sizeMobile ? '4' : '12'" class="btnDetail"
            :style="{display: 'flex', justifyContent: 'center', alignItems: 'center'}">
                <v-btn
                    class="register-btn"
                    color="primary"
                    block
                    @click="goToDetail()"
                    >
                    {{ $t('views.registered.btnDetail') }}
                </v-btn>
            </v-col>
          </v-row>
          <v-spacer class="my-10"></v-spacer>
            <!-- APP -->
          <v-row justify="center" class="rowCard">
            <v-col cols="3"
            :style="{display: 'flex', justifyContent: 'center', alignItems: 'center'}">
                <v-img
                  src="@/assets/appLogOut.png"
                  width="80"
                  height="80"
                  contain
                  class="mt-2"
                />
            </v-col>
            <v-col :cols="sizeScreen > sizeMobile ? '5' : '9'" class="">
                <div class="mt-3">
                    <h3>{{ sizeScreen > sizeMobile ? $t('views.registered.titleDownload')
                      : $t('views.registered.titleApp') }}</h3>
                    <ul class="custom-list">
                        <li>{{ $t('views.registered.subtitleDownload1') }}</li>
                        <li>{{ $t('views.registered.subtitleDownload2') }}</li>
                        <li>{{ $t('views.registered.subtitleDownload3') }}</li>
                    </ul>
                </div>
            </v-col>
            <!-- <v-col v-if="isWeb && sizeScreen < sizeMobile" -->
            <!-- :class="isWeb ? 'divNone': 'btnApp'" -->
            <v-col v-if="isWeb && sizeScreen < sizeMobile"
              :cols="sizeScreen > sizeMobile ? '4' : '12'"
              :class="isWeb ? 'btnApp': 'btnApp'"
              :style="{display: 'flex', justifyContent: 'center', alignItems: 'center'}">
              <!-- Si estamos en el navegador y esta instalada -->
                <v-btn
                    class="register-btn"
                    color="primary"
                    block
                    @click="downloadApp()"
                    >
                    {{ $t('views.registered.titleDownload') }}
                </v-btn>
              <!-- Si estamos en el navegador y no esta instalada -->

            </v-col>
            <v-col v-if="sizeScreen > sizeMobile" cols="2"
              :class="isWeb ? '': 'divNone'">
              <div class="container__badge">
                <img
                  alt="QR Android"
                  src="@/assets/QR_PlayStore.jpg"
                  width="100"
                />
                <a href="https://play.google.com/store/apps/details?id=es.juntadeandalucia.msspa.ayudadigital" target="_blank" rel="noopener">
                  <img alt="Android" class ="imagebadge"
                    src="@/assets/logo_badge_googlePlay.png" width="100" />
                </a>
              </div>
            </v-col>
            <v-col v-if="sizeScreen > sizeMobile" cols="2"
              :class="isWeb ? '': 'divNone'">
              <div class="container__badge">
                <img
                  alt="QR IOS"
                  src="@/assets/QR_AppStore.png"
                  width="100"
                />
                <a href="https://apps.apple.com/es/app/ayudadigital/id1531469960" target="_blank" rel="noopener">
                  <img
                    alt="iOS" src="@/assets/logo_badge_appStore.png"
                    width="100" class ="imagebadge"
                  />
                </a>
              </div>
            </v-col>
            <!-- {{ debug('VISTA') }} -->
          </v-row>
          <v-spacer class="my-10"></v-spacer>
            <!-- WHATSAPP -->
          <v-row justify="center" class="rowCard">
            <v-col cols="3"
            :style="{display: 'flex', justifyContent: 'center', alignItems: 'center'}">
                <v-icon size="80" color="success">
                    mdi-whatsapp
                </v-icon>
            </v-col>
            <v-col :cols="sizeScreen > sizeMobile ? 5 : 9" class="">
                <div class="mt-3">
                    <h3 class="mt-1">{{ $t('views.registered.titleWhatsApp') }}</h3>
                    <p>{{ sizeScreen > sizeMobile ? $t('views.registered.subtitleWhatsApp')
                      : $t('views.registered.subtitleMobile') }}</p>
                </div>
            </v-col>
            <v-col :cols="sizeScreen > sizeMobile ? 4 : 12" class="bntWhatsApp"
            :style="{display: 'flex', justifyContent: 'center', alignItems: 'center'}">
                <v-img
                  :class="sizeScreen > sizeMobile ? 'qrWhatsApp' : 'divNone'"
                  src="@/assets/qrWhatsapp.png">
                </v-img>
                <v-btn
                  :class="sizeScreen > sizeMobile ? 'divNone' : 'register-btn-whatsapp'"
                  color="primary"
                  block
                  @click="openWhatsApp('¡Hola! Quiero consultar mi solicitud.')"
                  >
                  {{ $t('views.registered.btnWhatsApp') }}
                </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    idTicket: {
      type: String,
      required: true,
    },
    type: {
      type: String,
    },
    name: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      isWeb: true,
      isAndroid: false,
      isIOS: false,
      isNavigator: false,
      sizeScreen: typeof window !== 'undefined' ? window.innerWidth : 0,
      sizeMobile: 426,
      isAppInstalled: false,
    };
  },
  methods: {
    // debug(e) {
    //   console.log('--- DEBUG REGISTERED REQUEST ---', { q: this.name, t: this });
    //   console.log(e, this.isWeb ? 'Escritorio/Movil Web' : 'Móvil/App');
    //   if (!this.isWeb) {
    //     console.log(this.isAndroid ? 'Android' : 'IOS');
    //   }
    //   console.log('sizeScreen:', this.sizeScreen);
    // },
    openWhatsApp(text) {
      const encoded = encodeURIComponent(text);
      const scheme = `whatsapp://send?phone=955017000&text=${encoded} ${this.name}`;
      const webFallback = `https://wa.me/?text=${encoded} ${this.name}`;

      // Intentar abrir esquema nativo
      window.location.href = scheme;

      // Si no se abre (app no instalada / navegador), hacer fallback tras 1.5s
      setTimeout(() => {
        // En la mayoría de casos el cambio de ubicación por el esquema rompe el flujo,
        // así que este fallback solo se ejecuta si seguimos en la misma página
        window.location.href = webFallback;
      }, 1500);
    },
    goToDetail() {
    //   goToLink(data) {
    //   const { filters } = this.params;
    //   const { type } = this.evalParam(filters, '');
    //   this.$router.push(`/element/${type.toLowerCase()}/${data.id}`);
      // const url = `/requests/${this.idTicket}`;
      this.$router.push(`/requests/${this.idTicket}`);
    },
    downloadApp() {
      // console.log('downloadApp');
      const playStore = 'https://play.google.com/store/apps/details?id=es.juntadeandalucia.msspa.ayudadigital';
      const appStore = 'https://apps.apple.com/es/app/ayudadigital/id1531469960';
      if (this.isAndroid) {
        window.open(playStore, '_blank');
      } else {
        window.open(appStore, '_blank');
        // No es ni Android ni iOS
        // alert(this.$t('views.registered.alertDownload'));
      }
    },
    // Comentada, hasta que se pueda comprabar 100% si tiene la app instalada es ese dispositivo
    // openApp() {
    //   // Intentar abrir la app mediante esquema personalizado
    //   const scheme = `https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/mics/requests/${this.idTicket}`;
    //   window.location.href = scheme;
    // },
    // 1) userAgent (Android / iOS)
    isMobileByUA() {
      const ua = (navigator.userAgent || '').toLowerCase();
      // console.log('isMobileByUA:', /android|iphone|ipad|ipod|windows phone/i.test(ua));
      return /android|iphone|ipad|ipod|windows phone/i.test(ua);
    },
    // 2) detectar WebView
    isInWebView() {
      // Flutter inappwebview
      // Si esta variable existe, significa que estamos en el webview de la app
      const flutter = !!window.flutter_inappwebview;
      // console.log('flutter', flutter);
      return flutter;
    },
    // 3) resultado final: móvil Y navegador (no WebView/app)
    isMobileBrowser() {
      return (this.isMobileByUA() && !this.isInWebView());
    },
    // Se lanza una petición de reseña en la app
    flutterRequestReview() {
      try {
        Vue.prototype.$flutterPort.postMessage('flutterReview');
      } catch (error) {
        console.log();
      }
    },
  },
  async created() {
    // Si la funcion isInWebView devuelve false, estamos en navegador
    this.isWeb = !this.isInWebView();

    // Comentada, hasta que se pueda comprabar 100% si tiene la app instalada es ese dispositivo
    // const userTokenList = await this.$api.getClient('userInfo').getAppInstalled();
    // this.isAppInstalled = userTokenList && userTokenList.length > 0;

    // Si estamos en un dispositivo movil
    if (!this.isWeb) {
      // Detectar si es Android o iOS
      const ua = (navigator.userAgent || '').toLowerCase();
      // Si no es web, el userAgent (Nos dice que esta en el navegador) nos indica el dispositivo
      this.isAndroid = /android/i.test(ua);
      this.isIOS = /iphone|ipad|ipod/i.test(ua);
      // console.log('isAndroid:', this.isAndroid, 'isIOS:', this.isIOS);

      // Si se crea una petición, se lanza una solicitud de review a la app
      if (this.type === 'r') {
        this.flutterRequestReview();
      }
    }
  },
  mounted() {
    this.sizeScreen = window.innerWidth;
  },
};
</script>

<style lang="scss" scoped>
.divNone{
  display: none;
}
.rowCard{
    display: flex;
    width: 100%;
    min-width: 100%;
    border: 1px solid gray;
    border-radius: 16px;
}
.registered-container {
  width: 100%;
  background: #fff;
  padding: 2rem !important;
  min-width: 100% !important;
  padding-left: 14rem !important;
  padding-right: 14rem !important;
  margin-top: 1rem !important;
}
.register-btn{
    color: #fff !important;
    font-weight: 600;
    box-shadow: none;
}
.register-btn-whatsapp {
  //margin-top: 16px !important;
}
.register-btn .v-icon {
  color: #fff !important;
}
.v-btn--block{
    min-width: 135px !important;
    max-width: 135px !important;
}
.v-text-field__details{
  display: none !important;
}
.btnDetail{
    display: flex;
    justify-content: right;
    align-items: center;
}
.btnApp{
    display: flex;
    justify-content: right;
    align-items: center;
}
.bntWhatsApp{
    display: flex;
    justify-content: right;
    align-items: center;
}
.qrWhatsApp{
    display: flex;
    justify-content: right;
    align-items: center;
    max-width: 100px !important;
    max-height: 100px !important;
}
.custom-list {
  font-size: 12px;
  padding-left: 18px; /* para mostrar el punto de lista */
}
.custom-list li {
  margin-bottom: 4px;
}
.container__badge {
  display: grid;
  justify-content: center;
  margin: 0 !important
}
.imagebadge {
  cursor: pointer;
  margin: 0 !important
}
@media screen and (max-width: 1024px) {
  .registered-container{
    padding-left: 8rem !important;
    padding-right: 8rem !important;
  }
}
@media screen and (max-width: 768px) {
  .registered-container{
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
}
@media screen and (max-width: 600px) {
    .v-btn--block{
        margin-top: 0px !important;
        min-width: 100% !important;
        max-width: 100% !important;
    }
    .register-btn-whatsapp{
        color: #fff !important;
        font-weight: 600;
        box-shadow: none;
    }
    .qrWhatsApp{
        display: none;
    }
    .registered-container{
      padding-left: 2rem !important;
      padding-right: 2rem !important;
    }
    .rowCard{
      margin-left: 0 !important;
      margin-right: 0 !important
    }
}
/* Consideramos Movil */
@media screen and (max-width: 425px) {
  .registered-container{
    margin-top: 0rem !important;
  }
}
</style>
<style>

</style>
